// Normalización de los metadatos dinámicos de una unidad externa para la ficha
// del drawer.
//
// Los pares los escribe la integración del tercero, así que el front no controla
// ni las llaves ni los tipos ni la longitud. Esta función es la única frontera
// entre eso y la plantilla: devuelve SIEMPRE un array de `{label, value}` con
// value string, para que un `v-for` no pueda reventar la ficha completa de la
// unidad por un documento mal formado.
//
// El orden se conserva: es el que eligió el proveedor, y el spec dice que se
// pinta tal cual.

// Un value más largo que esto desborda la zona y empuja el resto de la ficha
// fuera de vista. Se recorta para presentación; el dato completo sigue en la BD.
export var METADATA_VALUE_MAX = 120

// Etiquetas que la zona 1 ya muestra. Si la integración manda una igual, la
// fila se marca para que la plantilla la distinga en vez de contradecir en
// silencio lo que el operador ya está leyendo arriba.
var ETIQUETAS_ZONA_1 = [
  'unidad', 'organización', 'organizacion', 'estatus', 'estado',
  'última señal', 'ultima senal', 'velocidad', 'ubicación', 'ubicacion',
]

export function normalizeMetadataRows(raw) {
  if (!Array.isArray(raw)) return []
  var rows = []
  for (var i = 0; i < raw.length; i++) {
    var par = raw[i]
    if (!par || typeof par !== 'object' || Array.isArray(par)) continue
    var label = typeof par.label === 'string' ? par.label.trim() : ''
    if (!label) continue

    var value
    var t = typeof par.value
    if (t === 'string') value = par.value.trim()
    else if (t === 'number' || t === 'boolean') value = String(par.value)
    else continue

    if (!value) value = '—'
    else if (value.length > METADATA_VALUE_MAX) {
      value = value.slice(0, METADATA_VALUE_MAX) + '…'
    }

    var row = { label: label, value: value }
    if (ETIQUETAS_ZONA_1.indexOf(label.toLowerCase()) !== -1) {
      row.duplicaZona1 = true
    }
    rows.push(row)
  }
  return rows
}
